/* MAMO cart confirmation fallback. Used only if Sense's built-in notification is absent. */
(() => {
  'use strict';
  window.MAMOShowCartConfirmation = (activeElement) => {
    let shade = document.querySelector('.mamo-cart-fallback');
    if (!shade) {
      shade = document.createElement('div');
      shade.className = 'mamo-cart-fallback';
      shade.setAttribute('role', 'presentation');
      shade.innerHTML = `<div class="mamo-cart-fallback__dialog" role="dialog" aria-modal="true" aria-labelledby="mamo-cart-fallback-title" tabindex="-1">
        <h2 id="mamo-cart-fallback-title">Added to your bag</h2>
        <button type="button" class="button button--secondary" data-mamo-continue>Continue shopping</button>
        <a class="button button--primary" data-mamo-cart-link href="/cart">View cart</a>
      </div>`;
      document.body.appendChild(shade);
      shade.querySelector('[data-mamo-cart-link]').href = window.routes?.cart_url || '/cart';
    }
    const previous = activeElement instanceof HTMLElement ? activeElement : document.activeElement;
    const close = () => {
      shade.hidden = true;
      document.removeEventListener('keydown', onKey);
      if (previous?.isConnected && typeof previous.focus === 'function') previous.focus();
    };
    const onKey = (event) => {
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key === 'Tab') {
        const elements = [...shade.querySelectorAll('button, a')];
        if (!elements.length) return;
        const i = elements.indexOf(document.activeElement);
        if (event.shiftKey && i <= 0) { event.preventDefault(); elements[elements.length - 1].focus(); }
        else if (!event.shiftKey && i === elements.length - 1) { event.preventDefault(); elements[0].focus(); }
      }
    };
    shade.querySelector('[data-mamo-continue]').onclick = close;
    shade.onclick = (event) => { if (event.target === shade) close(); };
    shade.hidden = false;
    document.addEventListener('keydown', onKey);
    shade.querySelector('[data-mamo-continue]').focus();
  };
})();
